import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["prompt"]

  prompt(event) {
    event.preventDefault()
    event.stopImmediatePropagation()
    if (document.getElementById("chatLoginModal")) return

    const modal = this.promptTarget.content.firstElementChild.cloneNode(true)
    $(modal).one("hidden.bs.modal", () => {
      this.element.querySelector("textarea")?.focus()
    })
    document.body.appendChild(modal)
  }
}
